import { render, staticRenderFns } from "./CustomerContactTypeTranslationNewPopup.vue?vue&type=template&id=6b8285c4&"
import script from "./CustomerContactTypeTranslationNewPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerContactTypeTranslationNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports